import { MenuItem } from '../sidebar/menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "MENUITEMS.SEARCH.TEXT",
    link: "/search",
    icon: "bx bx-search-alt",
  },
  {
    id: 2,
    label: "MENUITEMS.ORDERS.TEXT",
    link: "/orders/myorders",
    icon: "bx bx-purchase-tag-alt",
  },
  {
    id: 3,
    label: "MENUITEMS.MYDOMAINS.TEXT",
    link: "/mydomains/domains",
  },
  {
    id: 6,
    label: "MENUITEMS.ACCOUNT.TEXT",
    link: "/account/profile",
  },
  {
    id: 10,
    label: "MENUITEMS.ADMIN.TEXT",
    icon: "bx bx-lock-alt",
    subItems: [
      // {
      //   id: 11,
      //   label: "MENUITEMS.ADMIN.LIST.API",
      //   link: "/admin/api",
      //   parentId: 10,
      // },
      {
        id: 12,
        label: "MENUITEMS.ADMIN.LIST.TRANSFER",
        link: "/admin/transfer",
        parentId: 10,
      },
    ],
  }
];
